import startsWith from 'lodash/startsWith';
import some from 'lodash/some';
import { useSelector } from 'react-redux';
import {
  useDDPSubscription,
  createEntitiesSelectors,
} from '@zedoc/ddp-connector';
import { urlNormalize } from '@zedoc/url';

const ServiceConfiguration = createEntitiesSelectors(
  'meteor_accounts_loginServiceConfiguration',
);

const useLoginServices = () => {
  const { ready } = useDDPSubscription({
    name: 'meteor.loginServiceConfiguration',
    params: [],
  });

  const services = useSelector(
    ServiceConfiguration.all().satisfying(({ appUrls }) => {
      return (
        !appUrls ||
        some(appUrls, (appUrl) =>
          startsWith(urlNormalize(window.location), appUrl),
        )
      );
    }),
  );

  return {
    ready,
    services,
  };
};

export default useLoginServices;
